/*global window._appConstants */
import * as axios from "axios";
import * as qs from "querystring";
import jwt from "jwt-decode";
import _ from 'lodash'; // Import lodash at the top of the file
import { buildApiUrl, buildOAuthUrl, buildUploadUrl, AppConfig } from '../../config/environment';

export const GET_AUTH_TOKEN = "GET_AUTH_TOKEN";
export const STORE_OAUTH_TOKEN = "_storeOAuthToken";
export const STORE_OTP_DATA = "_storeOtpData";
export const STORE_ACTIVE_INDEX = "_storeActiveIndex";
export const STORE_ALL_ROLES = "_storeAllRoles";
export const STORE_LOGIN_DATA = "_storeLoginData";
export const STORE_OEM_DATA = "_storeOemData";
export const CLEAR_ALL = "_clearAll";
const _storeActiveIndex = (oActiveIndex) => ({
  type: STORE_ACTIVE_INDEX,
  oActiveIndex,
});
const _storeAllRoles = (roles) => ({
  type: STORE_ALL_ROLES,
  roles,
});

const _storeOAuthToken = (oAuthData) => ({
  type: STORE_OAUTH_TOKEN,
  oAuthData,
});
const _storeLoginData = (loginUserData) => ({
  type: STORE_LOGIN_DATA,
  loginUserData,
});
const _storeOemData = (oemData) => ({
  type: STORE_OEM_DATA,
  oemData,
});
const _clearAll = () => ({ type: CLEAR_ALL });
const _storeOtpData = (otpData) => ({ type: STORE_OTP_DATA, otpData });

export function getOAuthToken(username, password) {
  return (dispatch) => {
    delete axios.defaults.headers.common["Authorization"];

    const data = {
      username,
      password,
      grant_type: "password",
    };

    const oauthUrl = buildOAuthUrl();
    console.log('[OAuth Debug] About to make POST request to:', oauthUrl);
    console.log('[OAuth Debug] Current environment config:', AppConfig);

    return axios
      .post(
          oauthUrl,
        qs.stringify(data),
        window._appConstants.useCommonDefaults.appAuthorization,
        window._appConstants.useCommonDefaults.app_headers
      )
      .then(function (response) {
        if (response.data && response.data.access_token) {
          axios.defaults.headers.common["Authorization"] =
            response.data.token_type + " " + response.data.access_token;
          const tokenDetails = jwt(response.data.access_token);
          // console.log(
          //   "tokenDetails: getOAuthToken: " + response.data.access_token
          // );
          dispatch(_storeOAuthToken(response.data));
        }
        return response.data;
      })
      .catch(function (err) {
        if (err.toString().toLowerCase().indexOf("network error") > -1) {
          console.log("Here");
          let data = {
            error: err,
            error_description: "Network Errror/Internet Connectivity Issue",
          };
          err.response = { data };
        }
        //for a vbgny CORS/Error cases
        return err.response.data;
      });
  };
}

export function refreshOAuthToken(refreshToken) {
  return (dispatch, state) => {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["realmName"];
    var loginBody = window._appConstants.useCommonDefaults.appAuthorization;
    const refreshOauthData = Object.assign({}, loginBody);
    delete refreshOauthData.username;
    delete refreshOauthData.password;
    delete refreshOauthData.auth;
    delete refreshOauthData["client_role"];

    refreshOauthData.refresh_token = refreshToken;
    refreshOauthData.grant_type = "refresh_token";

    axios
      .post(
        buildOAuthUrl(),
        qs.stringify(refreshOauthData),
        window._appConstants.useCommonDefaults.appAuthorization,
        window._appConstants.useCommonDefaults.app_headers
      )
      .then(function (response) {
        if (response.data && response.data.access_token) {
          axios.defaults.headers.common["Authorization"] =
            response.data.token_type + " " + response.data.access_token;
          axios.defaults.headers.common["realmName"] =
            window._appConstants.useCommonDefaults.REALM_NAME;
          dispatch(_storeOAuthToken(response.data));
          return true;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}
export function forgotPassword(username) {
  return (dispatch) => {
    return axios
      .patch(
        buildApiUrl('/forgotPassword'),
        {
          userName: username,
        }
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        if (err.toString().toLowerCase().indexOf("network error") > -1) {
          console.log("Here", err);
          let data = {
            error: err,
            message: "Network Errror/Internet Connectivity Issue",
          };
          err.response = { data };
        }
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function register(registrationId, password) {
  return (dispatch) => {
    return axios
      .patch(
        buildApiUrl(`/resetPassword/${registrationId}`),
        { password: password }
      )
      .then(function (response) {
        if (response.status == "200") {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        if (err.toString().toLowerCase().indexOf("network error") > -1) {
          console.log("Here");
          let data = {
            error: err,
            message: "Network Errror/Internet Connectivity Issue",
          };
          err.response = { data };
        }
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getRole() {
  return (dispatch) => {
    return axios
      .get(buildApiUrl("/role"))
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getUsersAll(makeID, page, tableSize) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/user?make_id=${makeID}&filter_attribute=name:&page=${page}&size=${tableSize}`)
      )
      .then(function (response) {
        return response.data;
        // if (response.data) {
        //   return response.data;
        // } else {
        //   return response.data;
        // }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getLoginUser(uid) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/user/${uid}`)
      )
      .then(function (response) {
        if (response.data) {
          dispatch(_storeLoginData(response.data));
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function updateUsers(uid, firstName, lastName, status) {
  return (dispatch) => {
    return axios
      .patch(
        buildApiUrl(`/user/${uid}`),
        {
          firstName: firstName,
          lastName: lastName,
          isActive: status,
        }
      )
      .then(function (response) {
        if (response.data) {
          console.log("response.data", response.data);
          return response.data;
        } else {
          console.log("response", response);
          return response.data;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function updateUsersPolicy(uid, data) {
  return (dispatch) => {
    return axios
      .patch(
        buildApiUrl(`/user/${uid}`),
        data
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return response.data;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function createUser(firstName, lastName, userName, roleUid, makeUid) {
  return (dispatch) => {
    return axios
      .post(
        buildApiUrl("/user"),
        {
          firstName: firstName,
          lastName: lastName,
          userName: userName,
          role: {
            uid: roleUid,
          },
          make: {
            uid: makeUid,
          },
        }
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getCountry() {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl("/country")
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getParentOems(makeUid) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/make/all/?option=add_oem&makeUid=${makeUid}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getState(countryUid) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/state/${countryUid}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getCity(stateUid) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/city/${stateUid}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function createPlant(
  plantCode,
  plantName,
  address,
  country,
  state,
  city,
  makeID
) {
  return (dispatch) => {
    return axios
      .post(
        buildApiUrl("/plant"),
        {
          plantCode: plantCode,
          plantName: plantName,
          address: address ? address : null,
          country: {
            uid: country ? country : null,
          },
          state: {
            uid: state ? state : null,
          },
          city: {
            uid: city ? city : null,
          },
          make: {
            uid: makeID,
          },
        }
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function uploadDoc(languageUid, vehicleModelUid, publicationTypeUid, formData) {
  return (dispatch) => {
    const uploadUrl = buildUploadUrl(languageUid, vehicleModelUid, publicationTypeUid);
    
    console.log("OAuth.uploadDoc - Making API call to:", uploadUrl);
    console.log("OAuth.uploadDoc - Upload parameters:", {
      languageUid,
      vehicleModelUid,
      publicationTypeUid
    });
    
    return axios
      .post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        console.log("✅ OAuth.uploadDoc - Server response:", response);
        console.log("✅ OAuth.uploadDoc - Response data:", response.data);
        console.log("✅ OAuth.uploadDoc - File storage location info:", {
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
          config: response.config
        });
        
        return response;
      })
      .catch(function (err) {
        console.error("❌ OAuth.uploadDoc - Upload error:", err);
        console.error("❌ OAuth.uploadDoc - Error response:", err.response?.data);
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function uploadOemDetails(formData) {
  return (dispatch) => {
    return axios
      .post(
        buildApiUrl("/vehicle/make"),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getLanguage() {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl("/vehicle/language")
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getPublicationTypes() {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl("/vehicle/publication-types")
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getMakeId() {
  return (dispatch) => {
    return axios
      .get(buildApiUrl("/make"))
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getModelVariant(makeId) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/modelVariant/${makeId}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getData(url) {
  return (dispatch) => {
    return axios
      .get(url)
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getManualLanguage(vID) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/manual/language/${vID}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getPlants(makeId) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/plant?page=0&size=999`,
        {
          params: {
            make_id: makeId,
          },
        }
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getUsers(makeId, roleId) {
  const url = `${AppConfig.API_URL}/user?role_id=${roleId}&make_id=${makeId}&filter_attribute=name:&page=0&size=999`;
  return (dispatch) => {
    return (
      axios
        .get(url)
        .then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        })
        .catch(function (err) {
          //for any CORS/Error cases
          return false;
        })
    );
  };
}

export function createInspection(data) {
  return (dispatch) => {
    // Debug: Log the request payload before sending
    //console.log("=== CREATE INSPECTION API REQUEST ===");
    //console.log("URL:", "https://ownermanualdev.bosch-automotive.com/ownersmanual/api/v1/vehicle/manual/inspection/job");
   // console.log("Request payload:", JSON.stringify(data, null, 2));
   // console.log("publicationTypeUid in payload:", data.publicationTypeUid);
   // console.log("=====================================");
    
    return axios
      .post(
        buildApiUrl("/vehicle/manual/inspection/job"),
        data
      )
      .then(function (response) {
       // console.log("Create Inspection Response Status:", response.status);
       // console.log("Create Inspection Response Data:", response.data);
        return response.status;
      })
      .catch(function (err) {
      //  console.error("Create Inspection Error:", err.response?.data || err.message);
       // console.error("Error status:", err.response?.status);
       // console.error("Error details:", err.response);
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}
export function getReportsData(makeId, object) {
  let url = "";
  if (object) {
    const objectData = _.cloneDeep(object);
    url = `${AppConfig.API_URL}/vehicle/manual/inspection/job/make?make_id=${makeId}&page=0&size=999&filter_attribute=technician_id:${objectData.technicianId};plant_id:${objectData.plantId};job_status:${objectData.jobStatus};model_name:${objectData.model_Name};market_id:${objectData.marketId};year_id:${objectData.yearId}`;
  } else {
    url = `${AppConfig.API_URL}/vehicle/manual/inspection/job/make?make_id=${makeId}&page=0&size=999`;
  }
  return (dispatch) => {
    return axios
      .get(url)
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        return false;
      });
  };
}

export function cancelUpdateJob(jobId, body) {
  return (dispatch) => {
    return axios
      .patch(
        `${AppConfig.API_URL}/vehicle/manual/inspection/job/${jobId}`,
        body
      )
      .then(function (response) {
        if (response) {
          return response;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        return false;
      });
  };
}
export function ClickHandler(index) {
  return (dispatch) => {
    dispatch(_storeActiveIndex(index));
    return true;
  };
}
export function multiTabCookieHandler(data) {
  return (dispatch) => {
    dispatch(_storeOAuthToken(data));
    return true;
  };
}
export function getAllModel(makeId) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/model/all/${makeId}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}
export function getBasicDetailsbyJobid(jobId) {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/manual/inspection/job/basic/info/${jobId}`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        console.log(err.response);
        if (err.response.status === 400) {
          return err.response.data;
        }
        return false;
      });
  };
}
export function getAllRole() {
  return (dispatch) => {
    return axios
      .get(`${AppConfig.API_URL}/role`)
      .then(function (response) {
        if (response.data) {
          dispatch(_storeAllRoles(response.data));
          return true;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}
export function getJobById(jobId) {
  return (dispatch) => {
    console.log("🔍 OAuth.getJobById - Fetching job data for ID:", jobId);
    
    return axios
      .get(
        `${AppConfig.API_URL}/vehicle/manual/inspection/job/${jobId}`
      )
      .then(function (response) {
        if (response.data) return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}
export function downloadAPK() {
  return (dispatch) => {
    return axios({
      url: `${AppConfig.API_URL}/vehicle/manual/inspection/job/mobile/app/download`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BQAA.apk"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };
}
export function getAllSecretQuestions() {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/user/secret/question`
      )
      .then(function (response) {
        if (response.data) return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function patchSecretanswer(registrationId, question, answer) {
  return (dispatch) => {
    return axios
      .patch(
        buildApiUrl(`/resetPassword/${registrationId}`),
        {
          secretQuestionMasterUid: question,
          secretAnswer: answer,
        }
      )
      .then(function (response) {
        if (response.status == "200") {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        if (err.toString().toLowerCase().indexOf("network error") > -1) {
          console.log("Here");
          let data = {
            error: err,
            message: "Network Errror/Internet Connectivity Issue",
          };
          err.response = { data };
        }
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}
export function uploadPolicy(docType, formData) {
  return (dispatch) => {
    return axios
      .post(
        `${AppConfig.API_URL}/user/consent/upload?documentType=${docType}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}
export function uploadUtilityExcel(docType, formData) {
  return (dispatch) => {
    return axios
      .post(
        `${AppConfig.API_URL}/${docType}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getBoshKitData() {
  return (dispatch) => {
    return axios
      .get(
        `${AppConfig.API_URL}/boshKitData?page=0&size=999`
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function updateBoshKitData(
  id,
  totalVolume,
  monthlyEstimatedVolumes,
  kitPrice,
  entryDate
) {
  return (dispatch) => {
    return axios
      .patch(
        `${AppConfig.API_URL}/boshKitData/${id}`,
        {
          totalVolume: totalVolume,
          monthlyEstimatedVolumes: monthlyEstimatedVolumes,
          kitPrice: kitPrice,
          entryDate: entryDate,
        }
      )
      .then(function (response) {
        if (response.data) {
          return true;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getTweddleData() {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/tweddle/erp?page=0&size=999`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getTweddleInvoiceData(
  shippedDate,
  shipmentNumber,
  shippedQuantity,
  partNumber,
  status,
  dueDate,
  startDate,
  endDate
) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/tweddle?filter_attribute=shipped_date:${shippedDate};shipment_number:${shipmentNumber};shipped_quantity:${shippedQuantity};part_number:${partNumber};status:${status};due_date:${dueDate};start_date:${startDate};end_date=${endDate}&page=0&size=999`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function getInvoiceDetails(tweddleShipmentDetailsUid, partNumber) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/tweddle/tweddleTransactionDetails/${tweddleShipmentDetailsUid}/${partNumber}`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}

export function postSentInvoiceData(invoice) {
  return (dispatch) => {
    return axios
      .post(
        buildApiUrl("/tweddle/status"),
        invoice
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getOemDashboard(makeUid) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/vehicle/make/all/?option=show_oem&makeUid=${makeUid}`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}
export function getAllOems() {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/vehicle/make?page=0&size=999`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return false;
        }
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return false;
      });
  };
}
export function addVehicle(data, makeId) {
  //localhost:48055/ownersmanual/api/v1/vehicle/make

  http: console.log("data, makeId", data, makeId);
  return (dispatch) => {
    return axios
      .post(
        buildApiUrl(`/vehicle/make/model/${makeId}`),
        data
        // qs.stringify(data)
        // window._appConstants.useCommonDefaults.app_staticUser,
        // window._appConstants.useCommonDefaults.app_headers
      )
      .then(function (response) {
        return response.status;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function getVehicleDetails(makeId) {
  console.log("data", makeId);
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/vehicle/model/${makeId}?page=0&size=999`)
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response.data;
      });
  };
}

export function deleteVehicleModel(modelUid, makeId) {
  return (dispatch) => {
    return axios
      .delete(
        buildApiUrl(`/vehicle/model/${modelUid}?makeUid=${makeId}`)
      )
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        //for any CORS/Error cases
        return err.response;
      });
  };
}

export function getCompanyImage(makeUid) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/vehicle/make/image?makeUid=${makeUid}`)
      )
      .then(function (response) {
        console.log("getCompanyImage Success", response);
        return response.data;
      })
      .catch(function (err) {
        //for any CORS/Error cases

        console.log("getCompanyImage error", err);
        return err.response.data;
      });
  };
}
export function downloadTweddle() {
  return (dispatch) => {
    return axios({
      url: buildApiUrl(`/tweddle/excel`),
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.
          data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "tweddle.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
      return response.data;
    });
  };
}
export function downloadMaster() {
  return (dispatch) => {
    return axios({
      url: buildApiUrl(`/boshKitData/excel`),
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "master.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
      return response.data;
    });
  };
}
export function getPublicationTypeByModelAndLanguage(vehicleModelUid, languageUid) {
  return (dispatch) => {
    return axios
      .get(
        buildApiUrl(`/vehicle/manual/inspection/job/publication-types/${vehicleModelUid}/${languageUid}`)
      )
      .then(function (response) {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      })
      .catch(function (err) {
        console.error("Error fetching publication type:", err);
        return [];
      });
  };
}

export function checkContentAvailability(vehicleModelUid) {
  return (dispatch) => {
    if (!vehicleModelUid) {
      return Promise.resolve({ isAvailable: false, message: "No vehicle selected" });
    }
    
    return axios
      .get(buildApiUrl(`/vehicle/content-available?vehicleModelUid=${vehicleModelUid}`))
      .then(function (response) {
        console.log("Content availability check successful:", response.data);
        // Check if response has uploadedFileName to determine if content is available
        const isAvailable = !!(response.data && response.data.uploadedFileName);
        return {
          isAvailable,
          data: response.data,
          message: isAvailable ? "Content available for this vehicle" : "No content available yet"
        };
      })
      .catch(function (err) {
        console.error("Error checking content availability:", err);
        // Return default response on error
        return {
          isAvailable: false,
          message: err.response?.data?.message || "Unable to check content availability"
        };
      });
  };
}
